import React, { ComponentType, PureComponent } from 'react';
import { CardContext } from 'services/CardContext';

const withCardContext = <P extends object>(Component: ComponentType<P>) => {
  class WithContext extends PureComponent<P> {
    render() {
      return <CardContext.Consumer>{value => <Component {...this.props} {...value} />}</CardContext.Consumer>;
    }
  }

  return WithContext;
};

export default withCardContext;
